import React, { SVGProps } from 'react';
type SVGRProps = {
  titleId?: string;
};
const SvgIcoNotificationBell = ({ titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 33 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    <title id={titleId}>NotificationBell</title>
    <path
      d="M18.378 6.712c.303-.467.48-1.028.48-1.63 0-1.625-1.28-2.941-2.857-2.941-1.578 0-2.857 1.316-2.857 2.94 0 .603.176 1.164.479 1.63M20.571 27.285a4.571 4.571 0 0 1-9.143 0"
      stroke="currentColor"
      strokeWidth={2}
    />
    <path
      d="M24 21.569V14.71a8 8 0 0 0-8-8 8 8 0 0 0-8 8v6.859c0 2.067-1.455 3.72-2.61 4.705-.356.305-.138 1.01.33 1.01h20.56c.469 0 .687-.705.33-1.01-1.154-.986-2.61-2.638-2.61-4.705Z"
      stroke="currentColor"
      strokeWidth={2}
    />
  </svg>
);
export default SvgIcoNotificationBell;
